module.exports = __webpack_public_path__ + "img/close_circle_outline.3ab69830.svg";